/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import React from "react";

import { CosmosVideo } from "@components/elements/atoms";
import { bgTextShade } from "@components/utils/css.utils";
import { CosmosAssetFragment } from "@cosmos/hygraph-schema";
import { css } from "@panda/css";

export const VideoShade = ({ asset }: { asset: CosmosAssetFragment }): React.JSX.Element | null => {
	if (!asset) return null;
	return (
		<>
			<CosmosVideo
				className={css({
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
					objectFit: "cover",
					zIndex: 0,
				})}
				video={asset}
				hideAttribution
			/>
			<div
				className={css({
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
					background: bgTextShade,
					zIndex: 1,
					pointerEvents: "none",
				})}
			/>
		</>
	);
};
